export default __webpack_public_path__ + "static/media/aer-lingus.bc045d4b.png";